<div class="title-components">
  <h1>Manuales</h1>
</div>

<!--&================== DIVIDER BUTONS LIBRARY ==================&-->
<div class="divider-butons-M">
  <button
    [class.Is-Disabled]="
      !UserService.UserRoleGeneralIn([
        RolesGeneral.Manuals,
        RolesGeneral.AdministratorCCP,
        RolesGeneral.AdministratorFIN,
        RolesGeneral.AdministratorSEC,
        RolesGeneral.AdministratorIT
      ])
    "
    [disabled]="
      !UserService.UserRoleGeneralIn([
        RolesGeneral.Manuals,
        RolesGeneral.AdministratorCCP,
        RolesGeneral.AdministratorFIN,
        RolesGeneral.AdministratorSEC,
        RolesGeneral.AdministratorIT
      ])
    "
    (click)="OpenModalIsUpdate(false, null)"
    class="btn-icon-text"
  >
    <i class="fa-solid fa-plus"></i><span class="text">Agregar Manual</span>
  </button>
</div>

<ng-container *ngIf="All_Manuals.length > 0 && LoadPage; else Not_Manual">
  <div class="Container-Card-Manuals">
    <div class="card-wrap" *ngFor="let Manual of All_Manuals">
      <div class="card-header {{ Type_Extension_Class(Manual.Extension) }}">
        <img
          src="./assets/Global/icon/{{ Type_Extension_Img(Manual.Extension) }}"
          alt=""
          srcset=""
        />
        <div
          *ngIf="
            UserService.UserRoleGeneralIn([
              RolesGeneral.Manuals,
              RolesGeneral.AdministratorCCP,
              RolesGeneral.AdministratorFIN,
              RolesGeneral.AdministratorSEC,
              RolesGeneral.AdministratorIT
            ])
          "
          class="Options-Manual"
        >
          <button
            (click)="OpenModalIsUpdate(true, Manual)"
            class="Btn-Option button-square Upload-M"
          >
            <i class="fa-solid fa-upload"></i>
          </button>
          <button
            (click)="Delete_Manual(Manual)"
            class="Btn-Option button-square Delete-M"
          >
            <i class="fa-regular fa-trash-can"></i>
          </button>
        </div>
      </div>
      <div class="card-content">
        <h1 class="card-title">{{ Cut_Name(Manual.Name) }}</h1>
        <p class="card-text">
          Descargue el manual presionando sobre el boton descargar
        </p>
        <button
          (click)="Download_Manual(Manual)"
          class="card-btn {{ Type_Extension_Class(Manual.Extension) }}"
        >
          Descargar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #Not_Manual>
  <div class="Container-Preview container-global-components">
    <div class="Not-Manual">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/Not-Annexes_See.png" alt="" />
      </div>
      <div class="Text-Not-Manual">
        ¡Hola {{ NameUser() }}, aun no hay manuales para mostrar!
      </div>
    </div>
  </div>
</ng-template>

<!---===================== MODAL FOR ADD MANUALS =====================--->
<section class="Modal-Global" id="ModalAddManual">
  <div class="wrapper">
    <div class="Pro-popup3 popup" id="Pro-popup3">
      <div class="Pro-inside3 popup-inside" id="Pro-inside3">
        <div class="Pro-backgrounds3 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Pro-content3 content" id="Pro-content3">
        <button (click)="ToggleModalAddManual(false)" class="Btn-Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <div class="Content-Top">
          <h2>{{ !IsUpdate ? "Cargar" : "Actualizar" }} manual</h2>
        </div>

        <div class="Content-body">
          <div class="Container-Drop">
            <input
              #AddManual
              type="file"
              class="file"
              (dragover)="Load_File()"
              (dragleave)="Onload_File()"
              (change)="Load_Document_Manual($event)"
            />
            <div class="Drag-Drop" id="Drag-Drop">
              <div class="Img">
                <img src="./assets/Global/Ilustrations/Add_Manual.png" alt="" />
              </div>
              <div class="Text">
                Suelte su archivo aquí, o
                <p>seleccione uno</p>
              </div>
              <div class="Subtitle">Soporta archivos PDF, PNG , PPTX ...</div>
            </div>
          </div>

          <div class="Container-Progress-Manual" id="Container-Progress-Manual">
            <div class="Title-Progress-Manual">
              <span>Cargando ...</span>
              <div id="Icon-Done" class="Icon-Done">
                <i class="fa-solid fa-check"></i>
              </div>
            </div>
            <div class="Container-Subtitle-Manual">
              <div class="TextSubtitle">
                <span id="TextProgress">0%</span>- un momento por favor
              </div>
            </div>
            <div class="Container-Progress-Bar-Manual">
              <div class="Progress-Bar-Manual" id="Progress-Bar-Manual"></div>
            </div>
          </div>
        </div>
        <div class="Content-Bottom Modal-Manual">
          <button
            (click)="ToggleModalAddManual(false)"
            class="Btn-LCancel-Form Btn-Close-Modal"
          >
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR FIN =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando Manual ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
